// import OSS from 'ali-oss'
export const OssRequset = async (aliInfo, endpoint, bucket) => {
  return new Promise(resolve => {
    const { accessKeyId, secretAccessKey, sessionToken } = aliInfo
    resolve(
      new OSS({
        endpoint: endpoint, // 云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
        accessKeyId: accessKeyId,
        accessKeySecret: secretAccessKey,
        bucket: bucket,
        stsToken: sessionToken
      })
    )
  })
}
